document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

$(window).scroll(function(){
	$('header').toggleClass('scrolled', $(this).scrollTop() > 200);
});

var initEventItemList = function () {
	let eventItemIterator = 1;
	let width = $(window).width();

	$('#program .eventItem').each(function () {
		if (eventItemIterator > 3 && width < 768) {
			$(this).hide();
		}
		else {
			$(this).show();
		}

		eventItemIterator += 1;
	});

	if (eventItemIterator > 3 && width < 768) {
		$('#showMoreEvent').show();
	}
	else {
		$('#showMoreEvent').hide();
	}
};

$('#showMoreEvent').click(function () {
	$('#program .eventItem').show();
	$(this).hide();
});

initEventItemList();
$(window).resize(initEventItemList);


// Select all links with hashes
$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function(event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
			&&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top - $('header').outerHeight()
				}, 1000, function() {
					// Callback after animation
					// Must change focus!
					var $target = $(target);
					$target.focus();
					if ($target.is(":focus")) { // Checking if the target was focused
						return false;
					} else {
						$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					};
				});
			}
		}
	});
